import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pluralization from 'plugins/pluralization.js'

Vue.use(VueI18n)

const language = sessionStorage.language

VueI18n.prototype.getChoiceIndex = pluralization.getChoiceIndex(language)

export const currentLang = () => {
  return language
}

export const i18n = (messages) => new VueI18n({
  silentTranslationWarn: true,
  locale: language,
  fallbackLocale: 'uk',
  dateTimeFormats: pluralization.dateTimeFormats,
  numberFormats: pluralization.numberFormats,
  messages
})